// extracted by mini-css-extract-plugin
export default {"theme":"Theme_theme__CS8kU","input":"Theme_input__FK4Vr","inner":"Theme_inner__KcOfa","box":"Theme_box__TlO4d","icon":"Theme_icon__KfhYV"};